import { apiClient } from '../utils/apiClient';

// Helper: İlk argüman firmCode (örn. 'beycelik') olarak gönderildiyse kaydırır
const isFirmCodeArg = (val) => typeof val === 'string' && val.length > 0 && isNaN(Number(val));

export const puantajQualityApi = {
    getList: async (arg1, arg2) => {
        // Hem getList(params) hem de getList(firmCode, params) çağrılarını destekler
        const params = (typeof arg1 === 'object' && arg1 !== null) ? arg1 : (arg2 || {});
        const query = new URLSearchParams();
        if (params.startDate) query.append('startDate', params.startDate);
        if (params.endDate) query.append('endDate', params.endDate);
        if (params.employeeId) query.append('employeeId', params.employeeId);
        if (params.status !== undefined && params.status !== null && params.status !== '') {
            query.append('status', params.status);
        }
        if (params.issueType) query.append('issueType', params.issueType);
        
        return await apiClient(`PuantajQuality?${query.toString()}`);
    },

    getDetail: async (arg1, arg2) => {
        // Hem getDetail(id) hem de getDetail(firmCode, id) çağrılarını destekler
        const id = arg2 !== undefined && arg2 !== null ? arg2 : arg1;
        return await apiClient(`PuantajQuality/${id}`);
    },

    accept: async (arg1, arg2, arg3) => {
        const id = isFirmCodeArg(arg1) ? arg2 : arg1;
        const note = isFirmCodeArg(arg1) ? arg3 : arg2;
        return await apiClient(`PuantajQuality/${id}/accept`, {
            method: 'POST',
            body: JSON.stringify({ note })
        });
    },

    revokeAccept: async (arg1, arg2, arg3) => {
        const id = isFirmCodeArg(arg1) ? arg2 : arg1;
        const note = isFirmCodeArg(arg1) ? arg3 : arg2;
        return await apiClient(`PuantajQuality/${id}/revoke-accept`, {
            method: 'POST',
            body: JSON.stringify({ note })
        });
    },

    applySuggestion: async (arg1, arg2, arg3, arg4) => {
        const id = isFirmCodeArg(arg1) ? arg2 : arg1;
        const suggestionId = isFirmCodeArg(arg1) ? arg3 : arg2;
        const note = isFirmCodeArg(arg1) ? arg4 : arg3;
        return await apiClient(`PuantajQuality/${id}/apply-suggestion`, {
            method: 'POST',
            body: JSON.stringify({ suggestionId, note })
        });
    },

    undo: async (arg1, arg2, arg3) => {
        const id = isFirmCodeArg(arg1) ? arg2 : arg1;
        const logId = isFirmCodeArg(arg1) ? arg3 : arg2;
        return await apiClient(`PuantajQuality/${id}/undo/${logId}`, {
            method: 'POST'
        });
    },

    manualCorrection: async (arg1, arg2, arg3, arg4, arg5) => {
        const id = isFirmCodeArg(arg1) ? arg2 : arg1;
        const secondArg = isFirmCodeArg(arg1) ? arg3 : arg2;
        if (typeof secondArg === 'object' && secondArg !== null) {
            return await apiClient(`PuantajQuality/${id}/manual-correction`, {
                method: 'POST',
                body: JSON.stringify({
                    time: secondArg.time,
                    recordType: parseInt(secondArg.recordType, 10),
                    note: secondArg.note
                })
            });
        }
        const time = secondArg;
        const recordType = isFirmCodeArg(arg1) ? arg4 : arg3;
        const note = isFirmCodeArg(arg1) ? arg5 : arg4;
        return await apiClient(`PuantajQuality/${id}/manual-correction`, {
            method: 'POST',
            body: JSON.stringify({ time, recordType: parseInt(recordType, 10), note })
        });
    },

    toggleIgnorePass: async (arg1, arg2, arg3, arg4) => {
        const id = isFirmCodeArg(arg1) ? arg2 : arg1;
        const passRecordId = isFirmCodeArg(arg1) ? arg3 : arg2;
        const note = isFirmCodeArg(arg1) ? arg4 : arg3;
        return await apiClient(`PuantajQuality/${id}/toggle-ignore-pass`, {
            method: 'POST',
            body: JSON.stringify({ passRecordId: parseInt(passRecordId, 10), note })
        });
    },

    flipPassDirection: async (arg1, arg2, arg3, arg4) => {
        const id = isFirmCodeArg(arg1) ? arg2 : arg1;
        const passRecordId = isFirmCodeArg(arg1) ? arg3 : arg2;
        const note = isFirmCodeArg(arg1) ? arg4 : arg3;
        return await apiClient(`PuantajQuality/${id}/flip-pass-direction`, {
            method: 'POST',
            body: JSON.stringify({ passRecordId: parseInt(passRecordId, 10), note })
        });
    },

    getDashboardSummary: async (arg1, arg2) => {
        const date = arg2 !== undefined && arg2 !== null ? arg2 : arg1;
        return await apiClient(`puantaj-quality/dashboard-summary?date=${date}`);
    },

    previewBatch: async (arg1, arg2) => {
        const data = (typeof arg1 === 'object' && arg1 !== null) ? arg1 : arg2;
        return await apiClient(`puantaj-quality/batch/preview`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
    },

    applyBatch: async (arg1, arg2) => {
        const data = (typeof arg1 === 'object' && arg1 !== null) ? arg1 : arg2;
        return await apiClient(`puantaj-quality/batch/apply`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
    },

    undoBatch: async (arg1, arg2) => {
        const batchLogId = arg2 !== undefined && arg2 !== null ? arg2 : arg1;
        return await apiClient(`puantaj-quality/batch/undo`, {
            method: 'POST',
            body: JSON.stringify({ batchLogId })
        });
    }
};
